class ForgotPassword extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.onsubmit = this.submit.bind(this);
  }

  submit(event) {
    event.preventDefault();
    this.clearError();
    this.querySelector('#password-form-success').style.display = 'none'
    
    if (!window.authUrl || window.authUrl == '') return;

    const values = {
      email: this.form.querySelector('input[name="email"]').value,
    }
    
    const button = event.target.querySelector('button[type="submit"]');

    button?.classList.add('loading');
    button?.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

    fetch(`${window.authUrl}/forgotPassword`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "email": values.email,
        "source": "shopify",
      })
    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.success) {
        this.querySelector('#password-form-success').style.display = 'block'
        button?.classList.remove('loading');
        button?.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      } else {
        if (forgot_password_form_error_codes[data.status_code]) {
          this.showError(forgot_password_form_error_codes[data.status_code], button);
        } else {
          this.showError(data.message, button);
        }
      }
    }).catch(error => {
      this.showError(error.message, button);
    }).finally(() => {
      this.querySelector('#password-form-submit').disabled = false;
    });
    
    return false;
  }

  showError(message, button){
    const errorWrapper = this.querySelector('#password-form-errors');
    const errorText = this.querySelector('#password-form-error-message');

    errorText.innerHTML = message;
    errorWrapper.style.display = 'block';
    setTimeout(() => {
      errorWrapper.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
    }, 500);
    
    button?.classList.remove('loading');
    button?.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
  }

  clearError(){
    const errorWrapper = this.querySelector('#password-form-errors');
    const errorText = this.querySelector('#password-form-error-message');

    errorText.innerHTML = '';
    errorWrapper.style.display = 'none';
  }
}

customElements.define('forgot-password-form', ForgotPassword);
